import { API } from '../Api';

// Interface for request parameters
interface GetTotalActiveUsersRequest {
  pageNumber: number;
  pageSize: number;
  fromDay: string;
  toDay: string;
}

export const fetchPostsApi = (page = 1, status = 'Uncheck', categoryId?: string) => {
  const param: {
    pageNumber: number;
    status?: string;
    pageSize: number;
    categoryId?: string;
  } = {
    pageNumber: page,
    status,
    // pageSize lớn (1000) làm get-uncheck timeout→500 khi có nhiều bài chờ duyệt
    // (import bài Cab xưa đẩy số lượng lên vài trăm) → CMS hiện "0". Phân trang thay vì tải hết.
    pageSize: 20,
  };
  if (status === 'Uncheck') {
    delete param.status;
  }
  if (categoryId) {
    param.categoryId = categoryId;
  }
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/post-service/admin/get-uncheck-posts', param)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

// Duyệt/loại HÀNG LOẠT bài chờ duyệt trong 1 danh mục (tab Cab xưa). status: 'Public' | 'Rejected'.
export const approveUncheckByCategory = (
  categoryId: string,
  status: string,
  reason?: string,
  totpCode?: string
) => {
  return new Promise<any>((resolve, reject) => {
    API.put(
      '/v1/post-service/admin/approve-uncheck-by-category',
      { categoryId, status, reason },
      { params: { totpCode } }
    )
      .then((res) => resolve(res))
      .catch(reject);
  });
};

export const fetchHiddenPostsApi = (page = 0) => {
  const param: { pageNumber: number; pageSize: number } = {
    pageNumber: page,
    pageSize: 1000,
  };

  return new Promise<any>((resolve, reject) => {
    API.post('/v1/post-service/admin/get-hidden-posts', param)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const handleAdminPostApi = (postId: string, status: string, reason?: string, totpCode?: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put('/v1/post-service/admin/approve', { postId, status, reason }, { params: { totpCode } })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const handleInvalidPostApi = (postId: string, status: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put('/v1/post-service/admin/update-invalid-post-status', {
      postId,
      status,
    })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const fetchReportPostsApi = () => {
  return new Promise<any>((resolve, reject) => {
    API.get('/v1/user-service/admin/profile/get-all-user-report-post')
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const fetchReportPostByStateApi = (state: StateReport) => {
  return new Promise<any>((resolve, reject) => {
    API.get(
      `/v1/user-service/admin/profile/get-report-post-by-state?state=${state}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const approveReportPostApi = (postId: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/user-service/admin/profile/approve-user-report-post/${postId}`)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
export const rejectReportPostApi = (postId: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/user-service/admin/profile/reject-user-report-post/${postId}`)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const getDashboardAdmin = () => {
  return new Promise<any>((resolve, reject) => {
    API.get(`/v1/user-service/admin/profile/dashboard/`)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
export const recoverPostApi = (postId: string) => {
  return new Promise<any>((resolve, reject) => {
    API.post(`/v1/post-service/admin/recover-report-point`, { postId })
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
// API function
export const getTotalActiveUsers = (params: GetTotalActiveUsersRequest) => {
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/user-service/admin/profile/get-total-active-users', params)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const fetchInvalidPostsAPI = (page = 0) => {
  const param: { pageNumber: number; pageSize: number } = {
    pageNumber: page,
    pageSize: 10,
  };
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/post-service/admin/get-invalid-posts', param)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
export enum StateReport {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
}

// Xem chi tiết 1 bài từ trang admin (bài bị báo cáo, bị ẩn, riêng tư, trong nhóm): dùng route admin, không dùng
// route người dùng `posts/{id}` vì route đó trả 404 cho bài người xem không được thấy.
export const getAdminPostDetail = (postId: string) =>
  API.get(`/v1/post-service/admin/${postId}`).then((res) => res.data);
